<nz-footer id="layout-footer" class="text-align-center">
  Swissport ©{{ year }}
</nz-footer>